import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_BREVSTATISTIKK_HISTORIKK = (svarUtReferanseId) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/brevstatistikk/historikk/${svarUtReferanseId}`;
